export default __webpack_public_path__ + "static/media/zsb-dead-logo.49826e33.png";